export default __webpack_public_path__ + "static/media/privilege-6.428306ff.svg";